module.exports = __webpack_public_path__ + "img/visa.7cd3f93e.svg";